import { useGetNotificationCounts, getGetNotificationCountsQueryKey } from "@workspace/api-client-react";
import { useAuth } from "@/hooks/use-auth";
import { useQueryClient } from "@tanstack/react-query";
import { useLocation } from "wouter";
import { useEffect } from "react";

export function useNotificationCounts() {
  const { isAuthenticated } = useAuth();
  const [location] = useLocation();
  const queryClient = useQueryClient();

  const { data } = useGetNotificationCounts({
    query: {
      queryKey: getGetNotificationCountsQueryKey(),
      enabled: isAuthenticated,
      refetchInterval: 60000,
      refetchOnWindowFocus: true,
    },
  });

  useEffect(() => {
    if (isAuthenticated) {
      queryClient.invalidateQueries({ queryKey: getGetNotificationCountsQueryKey() });
    }
  }, [location, isAuthenticated, queryClient]);

  return {
    unreadMessages: data?.unreadMessages ?? 0,
    newMatches: data?.newMatches ?? 0,
  };
}
